
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const SignUpLink = () => {
  const navigate = useNavigate();
  
  return (
    <div className="mt-4 text-center text-sm">
      <span className="text-muted-foreground">
        Vous n'avez pas de compte ?{" "}
      </span>
      <Button
        variant="link"
        className="p-0 h-auto font-semibold"
        onClick={() => navigate("/auth", { replace: true, state: { defaultTab: "signup" } })}
      >
        Créer un compte
      </Button>
    </div>
  );
};
